import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthPage as AuthPageView } from '../features/auth';
import { useAuth } from '../contexts/AuthContext';
import { getAccessToken } from '../lib/tokenStore';

const AuthPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Redirect already-logged-in users away from the login page
    const token = getAccessToken();
    if (token && user) {
      navigate(user?.role === 'student' ? '/dashboard' : '/feed');
    }
  }, [navigate, user]);

  return <AuthPageView />;
};

export default AuthPage;
